import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';

class SearchResItem extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.searchItemContainer}>
                {content.map((item, index) => (
                    <div className={styles.searchItem} key={index}>
                        <div className={styles.itemCenter}>
                            {/* <img src={item.employee_photo} alt={item.username} className={styles.photo} /> */}
                            <img
                                src={formatImage(item.employee_photo, 70, 105, 100)}
                                alt={item.username}
                                className={styles.photo}
                            />
                            <div className={styles.peopleInfo}>
                                <div className={styles.name}>{item.username}</div>
                                <span className={styles.redlines} />
                                <div className={styles.areaname}>{item.area_name}</div>
                                <img
                                    src="//x0.ifengimg.com/ucms/2021_37/022256F19CBA53F6D426C06FD3C17557FBE131A1_size1_w48_h30.png"
                                    className={styles.yihao}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default errorBoundary(SearchResItem);
